/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Fetcherror1Inputs */

const id_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal mengambil langganan. Silakan coba lagi.`)
};

const ms_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal mendapatkan langganan. Sila cuba lagi.`)
};

const da_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke hente abonnementer. Prøv venligst igen.`)
};

const de_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnements konnten nicht abgerufen werden. Bitte versuchen Sie es erneut.`)
};

const en_us2_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to fetch subscriptions. Please try again.`)
};

const es_es2_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al obtener las suscripciones. Inténtalo de nuevo.`)
};

const es_mx2_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al obtener las suscripciones. Intenta de nuevo.`)
};

const fil_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabigong makuha ang mga subscription. Pakisubukan muli.`)
};

const fr_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la récupération des abonnements. Veuillez réessayer.`)
};

const it_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile recuperare le sottoscrizioni. Riprova.`)
};

const hu_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A feliratkozások lekérése sikertelen. Kérjük, próbáld újra.`)
};

const nl_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnementen ophalen mislukt. Probeer het opnieuw.`)
};

const no_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke hente abonnementer. Prøv igjen.`)
};

const pl_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się pobrać subskrypcji. Spróbuj ponownie.`)
};

const pt_br2_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao buscar assinaturas. Por favor, tente novamente.`)
};

const pt_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao obter subscrições. Tente novamente.`)
};

const ro_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-au putut prelua abonamentele. Încearcă din nou.`)
};

const fi_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilausten nouto epäonnistui. Yritä uudelleen.`)
};

const sv_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunde inte hämta prenumerationer. Försök igen.`)
};

const vi_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể tải đăng ký. Vui lòng thử lại.`)
};

const tr_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelikler alınamadı. Lütfen tekrar deneyin.`)
};

const cs_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepodařilo se načíst odběry. Zkuste to prosím znovu.`)
};

const bg_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неуспешно извличане на абонаменти. Моля, опитайте отново.`)
};

const ru_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось получить подписки. Пожалуйста, попробуйте снова.`)
};

const uk_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не вдалося отримати підписки. Спробуйте ще раз.`)
};

const ar_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فشل في جلب الاشتراكات. حاول مرة أخرى.`)
};

const hi_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सब्सक्रिप्शन लाने में विफल। कृपया पुनः प्रयास करें।`)
};

const th_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่สามารถดึงข้อมูลการสมัครรับ กรุณาลองอีกครั้ง`)
};

const ja_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプションの取得に失敗しました。もう一度お試しください。`)
};

const zh_cn2_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获取订阅失败。请稍后再试。`)
};

const zh_hant1_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取得訂閱失敗。請稍後再試。`)
};

const ko_notifications_fetcherror1 = /** @type {(inputs: Notifications_Fetcherror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독을 불러오지 못했습니다. 다시 시도해 주세요.`)
};

/**
* | output |
* | --- |
* | "Failed to fetch subscriptions. Please try again." |
*
* @param {Notifications_Fetcherror1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_fetcherror1 = /** @type {((inputs?: Notifications_Fetcherror1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Fetcherror1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_fetcherror1(inputs)
	if (locale === "ms") return ms_notifications_fetcherror1(inputs)
	if (locale === "da") return da_notifications_fetcherror1(inputs)
	if (locale === "de") return de_notifications_fetcherror1(inputs)
	if (locale === "en-US") return en_us2_notifications_fetcherror1(inputs)
	if (locale === "es-ES") return es_es2_notifications_fetcherror1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_fetcherror1(inputs)
	if (locale === "fil") return fil_notifications_fetcherror1(inputs)
	if (locale === "fr") return fr_notifications_fetcherror1(inputs)
	if (locale === "it") return it_notifications_fetcherror1(inputs)
	if (locale === "hu") return hu_notifications_fetcherror1(inputs)
	if (locale === "nl") return nl_notifications_fetcherror1(inputs)
	if (locale === "no") return no_notifications_fetcherror1(inputs)
	if (locale === "pl") return pl_notifications_fetcherror1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_fetcherror1(inputs)
	if (locale === "pt") return pt_notifications_fetcherror1(inputs)
	if (locale === "ro") return ro_notifications_fetcherror1(inputs)
	if (locale === "fi") return fi_notifications_fetcherror1(inputs)
	if (locale === "sv") return sv_notifications_fetcherror1(inputs)
	if (locale === "vi") return vi_notifications_fetcherror1(inputs)
	if (locale === "tr") return tr_notifications_fetcherror1(inputs)
	if (locale === "cs") return cs_notifications_fetcherror1(inputs)
	if (locale === "bg") return bg_notifications_fetcherror1(inputs)
	if (locale === "ru") return ru_notifications_fetcherror1(inputs)
	if (locale === "uk") return uk_notifications_fetcherror1(inputs)
	if (locale === "ar") return ar_notifications_fetcherror1(inputs)
	if (locale === "hi") return hi_notifications_fetcherror1(inputs)
	if (locale === "th") return th_notifications_fetcherror1(inputs)
	if (locale === "ja") return ja_notifications_fetcherror1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_fetcherror1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_fetcherror1(inputs)
	return ko_notifications_fetcherror1(inputs)
});
export { notifications_fetcherror1 as "notifications.fetchError" }